(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ball-cutaway"] && !Shopify.designMode) return;
  try {
    
  N2T.whenThree(function (THREE) {
    const canvas = document.getElementById('cut-canvas');
    if (!canvas) return;

    const REDUCE = N2T.REDUCE;
    const TAU = N2T.TAU;

    /* ---------- cutaway ball ---------- */
    function makeCutawayBall() {
      const g = new THREE.Group();
      const CUT_START = Math.PI * 0.5,
        CUT_LEN = Math.PI * 1.5;
      const layers = [
        { r: 0.34, c: 0x8a6b45, rough: 0.95, solid: true },
        { r: 0.52, c: 0xc9b48c, rough: 0.85 },
        { r: 0.68, c: 0xf5f0e4, rough: 0.8 },
        { r: 0.84, c: 0x6e4b33, rough: 0.75 },
        { r: 1.0, c: 0xa31410, rough: 0.5 }
      ];
      layers.forEach((L) => {
        const geo = L.solid
          ? new THREE.SphereGeometry(L.r, 48, 36)
          : new THREE.SphereGeometry(L.r, 56, 40, CUT_START, CUT_LEN);
        g.add(
          new THREE.Mesh(
            geo,
            new THREE.MeshStandardMaterial({
              color: L.c,
              roughness: L.rough,
              metalness: 0.03,
              side: THREE.DoubleSide
            })
          )
        );
      });
      const seam = new THREE.Mesh(
        new THREE.TorusGeometry(0.998, 0.038, 12, 160),
        new THREE.MeshStandardMaterial({ color: 0x2a0a08, roughness: 0.75 })
      );
      seam.rotation.x = Math.PI / 2;
      g.add(seam);
      const rows = [0.062, 0.098, 0.134],
        perRow = 46;
      const inst = new THREE.InstancedMesh(
        new THREE.BoxGeometry(0.052, 0.014, 0.02),
        new THREE.MeshStandardMaterial({ color: 0xf5f0e4, roughness: 0.55 }),
        rows.length * 2 * perRow
      );
      const d = new THREE.Object3D();
      let i = 0;
      rows.forEach((off, r) => {
        [1, -1].forEach((side) => {
          for (let s = 0; s < perRow; s++) {
            const a = (s / perRow) * TAU + r * 0.03,
              y = side * off;
            const rad = Math.sqrt(Math.max(0.0001, 1 - y * y)) * 1.004;
            d.position.set(Math.cos(a) * rad, y, Math.sin(a) * rad);
            d.lookAt(0, 0, 0);
            d.rotateZ(side * 0.62);
            d.updateMatrix();
            inst.setMatrixAt(i++, d.matrix);
          }
        });
      });
      g.add(inst);
      return g;
    }

    const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
    camera.position.set(0, 0, 4.4);
    scene.add(new THREE.AmbientLight(0xffffff, 0.44));
    const key = new THREE.DirectionalLight(0xfff6e2, 1.15);
    key.position.set(-3.2, 4.0, 3.8);
    scene.add(key);
    const rim = new THREE.DirectionalLight(0xd9b865, 1.3);
    rim.position.set(4.0, -1.2, -3.0);
    scene.add(rim);
    const fill = new THREE.DirectionalLight(0x3a6bc4, 0.45);
    fill.position.set(3.0, 2.0, 2.2);
    scene.add(fill);
    const inner = new THREE.PointLight(0xfff3dc, 0.9, 6);
    inner.position.set(1.6, 0.6, 1.6);
    scene.add(inner);

    const pivot = new THREE.Group();
    pivot.add(makeCutawayBall());
    pivot.rotation.set(0.22, -0.9, 0.28);
    scene.add(pivot);

    let vx = 0.0034,
      vy = 0,
      dragging = false,
      lx = 0,
      ly = 0;
    function down(e) {
      dragging = true;
      lx = e.touches ? e.touches[0].clientX : e.clientX;
      ly = e.touches ? e.touches[0].clientY : e.clientY;
    }
    function move(e) {
      if (!dragging) return;
      const cx = e.touches ? e.touches[0].clientX : e.clientX,
        cy = e.touches ? e.touches[0].clientY : e.clientY;
      vx = (cx - lx) * 0.0055;
      vy = (cy - ly) * 0.0045;
      pivot.rotation.y += vx;
      pivot.rotation.x += vy;
      lx = cx;
      ly = cy;
      if (e.cancelable) e.preventDefault();
    }
    function up() {
      dragging = false;
    }
    canvas.addEventListener('mousedown', down);
    canvas.addEventListener('touchstart', down, { passive: true });
    addEventListener('mousemove', move);
    addEventListener('touchmove', move, { passive: false });
    addEventListener('mouseup', up);
    addEventListener('touchend', up);
    function resize() {
      const r = canvas.getBoundingClientRect();
      if (!r.width || !r.height) return;
      renderer.setSize(r.width, r.height, false);
      camera.aspect = r.width / r.height;
      camera.updateProjectionMatrix();
    }
    addEventListener('resize', resize);
    resize();
    function loop() {
      requestAnimationFrame(loop);
      if (!dragging) {
        pivot.rotation.y += vx;
        pivot.rotation.x += vy;
        vx += (0.0034 - vx) * 0.035;
        vy *= 0.93;
        pivot.rotation.x += (0.22 - pivot.rotation.x) * 0.02;
      }
      renderer.render(scene, camera);
    }
    if (REDUCE) renderer.render(scene, camera);
    else loop();
    setTimeout(resize, 60);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-filters"]) return;
  try {
    
  (function () {
    const ftoggle = document.getElementById('ftoggle');
    const rail = document.getElementById('rail');
    if (ftoggle && rail) {
      ftoggle.addEventListener('click', function () { rail.classList.toggle('show'); });
    }

    const sortSelect = document.getElementById('sort_by');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        document.getElementById('sort-form').submit();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.getElementById('cform');
    if (!form || form.dataset.n2tBound) return;
    form.dataset.n2tBound = 'true';

    const hidden = document.getElementById('topic-value');
    document.querySelectorAll('#topic button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (hidden) hidden.value = b.dataset.v;
        document.querySelectorAll('#topic button').forEach(function (x) {
          x.setAttribute('aria-pressed', x === b);
        });
      });
    });

    function fail(id, msg) {
      const f = document.getElementById(id);
      f.classList.add('bad');
      if (msg) {
        const e = f.querySelector('.err');
        if (e) e.textContent = msg;
      }
      return false;
    }
    function pass(id) {
      document.getElementById(id).classList.remove('bad');
      return true;
    }

    form.addEventListener('submit', function (e) {
      let ok = true;
      ok = (document.getElementById('name').value.trim() ? pass('f-name') : fail('f-name')) && ok;
      const em = document.getElementById('email').value.trim();
      if (!em) ok = fail('f-email', form.dataset.errEmail) && ok;
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) ok = fail('f-email', form.dataset.errEmailFormat) && ok;
      else pass('f-email');
      ok = (document.getElementById('country').value ? pass('f-country') : fail('f-country')) && ok;
      ok = (document.getElementById('msg').value.trim() ? pass('f-msg') : fail('f-msg')) && ok;

      if (!ok) {
        e.preventDefault();
        const first = form.querySelector('.field.bad input,.field.bad select,.field.bad textarea');
        if (first) first.focus();
      }
    });

    ['name', 'email', 'msg'].forEach(function (id) {
      const el = document.getElementById(id);
      if (el) el.addEventListener('input', function () { el.closest('.field').classList.remove('bad'); });
    });
    const country = document.getElementById('country');
    if (country) country.addEventListener('change', function () { pass('f-country'); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hero"] && !Shopify.designMode) return;
  try {
    
  N2T.whenThree(function (THREE) {
    const gc = document.getElementById('globe-canvas');
    const hubsTag = document.getElementById('globe-hubs');
    if (!gc || !hubsTag) return;

    const REDUCE = N2T.REDUCE;
    // Coordinates come from text settings, so coerce before any arithmetic.
    const HUBS = JSON.parse(hubsTag.textContent)
      .map(function (h) {
        return { name: h.name, lat: parseFloat(h.lat), lon: parseFloat(h.lon), origin: h.origin };
      })
      .filter(function (h) {
        return isFinite(h.lat) && isFinite(h.lon);
      });
    if (!HUBS.length) return;

    function latLon(lat, lon, r) {
      const phi = ((90 - lat) * Math.PI) / 180;
      const theta = ((lon + 180) * Math.PI) / 180;
      return new THREE.Vector3(
        -r * Math.sin(phi) * Math.cos(theta),
        r * Math.cos(phi),
        r * Math.sin(phi) * Math.sin(theta)
      );
    }

    const renderer = new THREE.WebGLRenderer({ canvas: gc, antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
    camera.position.set(0, 0, 4.6);

    scene.add(new THREE.AmbientLight(0xffffff, 0.5));
    const key = new THREE.DirectionalLight(0xffffff, 1.0);
    key.position.set(-3, 3, 4);
    scene.add(key);
    const rim = new THREE.DirectionalLight(0xa31410, 1.2);
    rim.position.set(3.5, -1, -3);
    scene.add(rim);

    const globe = new THREE.Group();
    scene.add(globe);

    // solid dark sphere
    globe.add(
      new THREE.Mesh(
        new THREE.SphereGeometry(1.4, 48, 36),
        new THREE.MeshStandardMaterial({ color: 0x04193d, roughness: 0.95, metalness: 0.1 })
      )
    );

    // lat/long grid
    const grid = new THREE.LineSegments(
      new THREE.WireframeGeometry(new THREE.SphereGeometry(1.405, 26, 16)),
      new THREE.LineBasicMaterial({ color: 0xf5f0e4, transparent: true, opacity: 0.13 })
    );
    globe.add(grid);

    // equator, picked out
    const eq = new THREE.Mesh(
      new THREE.TorusGeometry(1.408, 0.006, 8, 128),
      new THREE.MeshBasicMaterial({ color: 0xd9b865, transparent: true, opacity: 0.55 })
    );
    eq.rotation.x = Math.PI / 2;
    globe.add(eq);

    // hub markers
    const pulses = [];
    HUBS.forEach((h) => {
      const pos = latLon(h.lat, h.lon, 1.4);
      const dot = new THREE.Mesh(
        new THREE.SphereGeometry(h.origin ? 0.048 : 0.036, 16, 12),
        new THREE.MeshBasicMaterial({ color: h.origin ? 0xf5f0e4 : 0xd4241a })
      );
      dot.position.copy(pos);
      globe.add(dot);

      const ring = new THREE.Mesh(
        new THREE.RingGeometry(0.06, 0.078, 26),
        new THREE.MeshBasicMaterial({ color: 0xd9b865, transparent: true, opacity: 0.7, side: THREE.DoubleSide })
      );
      ring.position.copy(pos);
      ring.lookAt(pos.clone().multiplyScalar(2));
      globe.add(ring);
      pulses.push(ring);
    });

    // arcs from the origin hub outwards
    const origin = latLon(HUBS[0].lat, HUBS[0].lon, 1.4);
    const flights = [];
    HUBS.slice(1).forEach((h) => {
      const end = latLon(h.lat, h.lon, 1.4);
      const mid = origin
        .clone()
        .add(end)
        .multiplyScalar(0.5)
        .normalize()
        .multiplyScalar(1.4 + origin.distanceTo(end) * 0.3);
      const curve = new THREE.QuadraticBezierCurve3(origin, mid, end);
      const pts = curve.getPoints(64);

      globe.add(
        new THREE.Line(
          new THREE.BufferGeometry().setFromPoints(pts),
          new THREE.LineBasicMaterial({ color: 0xa31410, transparent: true, opacity: 0.55 })
        )
      );

      // a package travelling the route
      const pkg = new THREE.Mesh(
        new THREE.SphereGeometry(0.028, 10, 8),
        new THREE.MeshBasicMaterial({ color: 0xd9b865 })
      );
      globe.add(pkg);
      flights.push({ curve, pkg, t: Math.random() });
    });

    globe.rotation.set(0.28, -1.6, 0.12);

    let vx = 0.0022,
      vy = 0,
      dragging = false,
      lx = 0,
      ly = 0;
    function down(e) {
      dragging = true;
      lx = e.touches ? e.touches[0].clientX : e.clientX;
      ly = e.touches ? e.touches[0].clientY : e.clientY;
    }
    function move(e) {
      if (!dragging) return;
      const cx = e.touches ? e.touches[0].clientX : e.clientX,
        cy = e.touches ? e.touches[0].clientY : e.clientY;
      vx = (cx - lx) * 0.005;
      vy = (cy - ly) * 0.004;
      globe.rotation.y += vx;
      globe.rotation.x += vy;
      lx = cx;
      ly = cy;
      if (e.cancelable) e.preventDefault();
    }
    function up() {
      dragging = false;
    }
    gc.addEventListener('mousedown', down);
    gc.addEventListener('touchstart', down, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);

    function resize() {
      const r = gc.getBoundingClientRect();
      if (!r.width || !r.height) return;
      renderer.setSize(r.width, r.height, false);
      camera.aspect = r.width / r.height;
      camera.updateProjectionMatrix();
    }
    window.addEventListener('resize', resize);
    resize();

    let clock = 0;
    function loop() {
      requestAnimationFrame(loop);
      clock += 0.016;
      if (!dragging) {
        globe.rotation.y += vx;
        globe.rotation.x += vy;
        vx += (0.0022 - vx) * 0.035;
        vy *= 0.93;
        globe.rotation.x += (0.28 - globe.rotation.x) * 0.02;
      }
      // marker pulse
      const s = 1 + Math.sin(clock * 2.2) * 0.28;
      pulses.forEach((r, i) => {
        r.scale.setScalar(s + i * 0.04);
        r.material.opacity = 0.3 + (1.3 - s) * 0.5;
      });
      // packages in transit
      flights.forEach((f) => {
        f.t += 0.0026;
        if (f.t > 1) f.t = 0;
        f.pkg.position.copy(f.curve.getPoint(f.t));
      });
      renderer.render(scene, camera);
    }
    if (REDUCE) renderer.render(scene, camera);
    else loop();
    setTimeout(resize, 60);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enquiry-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.getElementById('cform');
    if (!form) return;

    /* ---------- enquiry type ---------- */
    const hidden = document.getElementById('topic-value');
    document.querySelectorAll('#topic button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (hidden) hidden.value = b.dataset.v;
        document.querySelectorAll('#topic button').forEach(function (x) {
          x.setAttribute('aria-pressed', x === b);
        });
      });
    });

    /* ---------- validation ---------- */
    function fail(id, msg) {
      const f = document.getElementById(id);
      f.classList.add('bad');
      if (msg) {
        const e = f.querySelector('.err');
        if (e) e.textContent = msg;
      }
      return false;
    }
    function pass(id) {
      document.getElementById(id).classList.remove('bad');
      return true;
    }

    form.addEventListener('submit', function (e) {
      let ok = true;
      ok = (document.getElementById('name').value.trim() ? pass('f-name') : fail('f-name')) && ok;
      const em = document.getElementById('email').value.trim();
      if (!em) ok = fail('f-email', form.dataset.errEmail) && ok;
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) ok = fail('f-email', form.dataset.errEmailFormat) && ok;
      else pass('f-email');
      ok = (document.getElementById('country').value ? pass('f-country') : fail('f-country')) && ok;
      ok = (document.getElementById('msg').value.trim() ? pass('f-msg') : fail('f-msg')) && ok;

      if (!ok) {
        e.preventDefault();
        const first = form.querySelector('.field.bad input,.field.bad select,.field.bad textarea');
        if (first) first.focus();
      }
      // Valid submissions fall through to Shopify's contact endpoint.
    });

    ['name', 'email', 'msg'].forEach(function (id) {
      const el = document.getElementById(id);
      if (el) el.addEventListener('input', function () { el.closest('.field').classList.remove('bad'); });
    });
    const country = document.getElementById('country');
    if (country) country.addEventListener('change', function () { pass('f-country'); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.gal').forEach(function (root) {
    var grid = root.querySelector('.gal-grid');
    if (!grid) return;
    var sectionId = grid.id.replace('gal-grid-', '');
    var dataTag = document.getElementById('gal-data-' + sectionId);
    var lb = document.getElementById('gal-lb-' + sectionId);
    var tiles = Array.prototype.slice.call(grid.querySelectorAll('.gal-tile'));
    if (!tiles.length) return;

    var DATA = [];
    try { DATA = JSON.parse(dataTag.textContent); } catch (e) { DATA = []; }

    /* ---------- chip counts ---------- */
    root.querySelectorAll('[data-count-for]').forEach(function (sup) {
      var cat = sup.dataset.countFor;
      sup.textContent = cat === 'all'
        ? tiles.length
        : tiles.filter(function (t) { return t.dataset.cat === cat; }).length;
    });

    /* ---------- staggered reveal ---------- */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var visible = tiles.filter(function (t) { return !t.hidden; });
        entry.target.style.transitionDelay = (Math.min(visible.indexOf(entry.target) % 6, 5) * 55) + 'ms';
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    tiles.forEach(function (t) { io.observe(t); });

    /* ---------- filters ---------- */
    root.querySelectorAll('.gal-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var cat = chip.dataset.cat;
        root.querySelectorAll('.gal-chip').forEach(function (c) {
          c.setAttribute('aria-pressed', String(c === chip));
        });
        tiles.forEach(function (t) {
          t.hidden = !(cat === 'all' || t.dataset.cat === cat);
          if (!t.hidden) { t.classList.add('is-in'); t.style.transitionDelay = '0ms'; }
        });
      });
    });

    /* ---------- lightbox ---------- */
    if (!lb) return;
    var fig = lb.querySelector('.gal-lb__fig');
    var cap = lb.querySelector('.gal-lb__cap');
    var idx = lb.querySelector('.gal-lb__idx');
    var current = 0;
    var lastFocus = null;

    function visibleIndexes() {
      return tiles.reduce(function (acc, t, i) { if (!t.hidden) acc.push(i); return acc; }, []);
    }

    function render(i) {
      var d = DATA[i];
      if (!d) return;
      current = i;
      fig.innerHTML = '';

      if (d.videoSources && d.videoSources.length) {
        var v = document.createElement('video');
        v.controls = true; v.autoplay = true; v.playsInline = true; v.setAttribute('poster', d.image || '');
        d.videoSources.forEach(function (s) {
          var src = document.createElement('source');
          src.src = s.url; src.type = s.mime; v.appendChild(src);
        });
        fig.appendChild(v);
      } else if (d.embedType === 'youtube' && d.embedId) {
        var yt = document.createElement('iframe');
        yt.src = 'https://www.youtube.com/embed/' + d.embedId + '?autoplay=1&rel=0';
        yt.allow = 'autoplay; encrypted-media; picture-in-picture'; yt.allowFullscreen = true;
        fig.appendChild(yt);
      } else if (d.embedType === 'vimeo' && d.embedId) {
        var vm = document.createElement('iframe');
        vm.src = 'https://player.vimeo.com/video/' + d.embedId + '?autoplay=1';
        vm.allow = 'autoplay; picture-in-picture'; vm.allowFullscreen = true;
        fig.appendChild(vm);
      } else if (d.image) {
        var img = document.createElement('img');
        img.src = d.image; img.alt = d.caption || '';
        fig.appendChild(img);
      }

      cap.textContent = d.caption || '';
      idx.textContent = [d.number, d.category].filter(Boolean).join(' · ');
    }

    function step(dir) {
      var vis = visibleIndexes();
      if (!vis.length) return;
      var at = vis.indexOf(current);
      render(vis[(at + dir + vis.length) % vis.length]);
    }

    function open(i) {
      lastFocus = document.activeElement;
      render(i);
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
      lb.querySelector('.gal-lb__close').focus();
    }

    function close() {
      lb.classList.remove('open');
      fig.innerHTML = '';
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function () { open(parseInt(t.dataset.index, 10)); });
    });
    lb.querySelector('.gal-lb__close').addEventListener('click', close);
    lb.querySelector('.gal-lb__next').addEventListener('click', function () { step(1); });
    lb.querySelector('.gal-lb__prev').addEventListener('click', function () { step(-1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const burger = document.getElementById('burger');
  const navlinks = document.getElementById('navlinks');
  if (burger && navlinks) {
    burger.addEventListener('click', () => {
      const o = navlinks.classList.toggle('open');
      burger.setAttribute('aria-expanded', o);
      burger.textContent = o ? '✕' : '☰';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  N2T.whenThree(function (THREE) {
    const heroCanvas = document.getElementById('hero-canvas');
    if (!heroCanvas) return;
    const hv = N2T.Viewer(THREE, heroCanvas, { dist: 4.3, dust: true, bob: true });
    const ball = N2T.makeBall(THREE, undefined, undefined, true);
    ball.rotation.z = 0.34;
    hv.setModel(ball);
    setTimeout(hv.resize, 60);
    if (N2T.REDUCE) hv.render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-inspector"] && !Shopify.designMode) return;
  try {
    
  N2T.whenThree(function (THREE) {
    const bayCanvas = document.getElementById('bay-canvas');
    const dataTag = document.getElementById('bay-specs-data');
    if (!bayCanvas || !dataTag) return;

    const DATA = JSON.parse(dataTag.textContent);
    const bv = N2T.Viewer(THREE, bayCanvas, { dist: 5.6, spin: 0.0038 });
    const factories = {
      ball: function () { return N2T.makeBall(THREE); },
      bat: function () { return N2T.makeBat(THREE); },
      bag: function () { return N2T.makeBag(THREE); }
    };
    const models = {};
    const dists = { ball: 4.4, bat: 6.4, bag: 5.6 };

    function pick(index) {
      const entry = DATA[index];
      if (!entry) return;
      const kind = entry.model;
      if (!models[kind]) models[kind] = (factories[kind] || factories.ball)();

      bv.setModel(models[kind]);
      bv.camera.position.z = dists[kind] || 5.2;

      // "Label | Value" per line, mirroring the original spec table.
      document.getElementById('bayspecs').innerHTML = (entry.specs || '')
        .split('\n')
        .map(function (line) { return line.split('|'); })
        .filter(function (parts) { return parts.length === 2; })
        .map(function (parts) {
          const cell = document.createElement('div');
          cell.textContent = parts[0].trim();
          const label = cell.innerHTML;
          cell.textContent = parts[1].trim();
          return '<li><b>' + label + '</b><span>' + cell.innerHTML + '</span></li>';
        })
        .join('');

      document.querySelectorAll('.sw').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.index === String(index));
      });
      if (N2T.REDUCE) bv.render();
    }

    document.querySelectorAll('.sw').forEach(function (b) {
      b.addEventListener('click', function () { pick(b.dataset.index); });
    });
    pick('0');
    setTimeout(bv.resize, 60);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  // Every video hero autoplays muted — browsers will not autoplay audio, so a
  // gesture is required before sound can start. Two ways to give it: the
  // optional sound button, or clicking the film itself.
  document.querySelectorAll('.vhero').forEach(function (hero) {
    var video = hero.querySelector('video');
    if (!video) return;

    var btn = hero.querySelector('.vhero-sound');
    var label = btn ? btn.querySelector('span') : null;
    var hint = hero.querySelector('.vhero-soundhint');

    function apply(muted) {
      video.muted = muted;
      if (!muted && video.paused) video.play();
      hero.classList.toggle('is-unmuted', !muted);
      // Set opacity directly rather than relying on the class alone, so the
      // hint reliably clears once sound is on.
      if (hint) hint.style.opacity = muted ? '' : '0';
      if (btn) {
        btn.setAttribute('aria-pressed', String(!muted));
        label.textContent = muted ? label.dataset.labelOff : label.dataset.labelOn;
      }
    }

    if (btn) btn.addEventListener('click', function () { apply(!video.muted); });

    var layer = hero.querySelector('.vhero-unmute');
    if (layer) layer.addEventListener('click', function () { apply(!video.muted); });
  });

  } catch(e) { console.error(e); }
})();
})();
